import React from 'react'
import { midas } from '@resurs/midas'
import { getText } from '../../../../../internal/TextLabels'
import styles from './order.style'

const OrderCaptions = () => (
  <div style={styles.table} className={`${midas.columns}`}>
    <div
      style={styles.tableCaption}
      className={`${midas.column} ${midas.col2}`}
    >
      {getText('payApply.order.articleNbr')}
    </div>
    <div
      style={styles.tableCaption}
      className={`${midas.column} ${midas.col3}`}
    >
      {getText('payApply.order.description')}
    </div>
    <div
      style={styles.tableCaption}
      className={`${midas.column} ${midas.col1}`}
    >
      {getText('payApply.order.quantity')}
    </div>
    <div
      style={styles.tableCaptionMultiLine}
      className={`${midas.column} ${midas.col2}`}
    >
      {getText('payApply.order.unitPrice')}
    </div>
    <div
      style={styles.tableCaptionMultiLine}
      className={`${midas.column} ${midas.col1}`}
    >
      {getText('payApply.order.vat')}
    </div>
    <div
      style={styles.innerTableCell}
      className={`${midas.column} ${midas.col3}`}
    >
      <div style={styles.innerTable} className={`${midas.columns}`}>
        <div
          style={styles.tableCaption}
          className={`${midas.column} ${midas.col6}`}
        >
          {getText('payApply.order.sum')}
        </div>
        <div
          style={styles.tableCaptionMultiLine}
          className={`${midas.column} ${midas.col6}`}
        >
          {getText('payApply.order.vatTotal')}
        </div>
      </div>
    </div>
  </div>
)

export default OrderCaptions
